export default __webpack_public_path__ + "static/Theme-58ce48c3a02585f43e6007da1a9363a4.png";